import { render } from "./ProductModelDetails.vue?vue&type=template&id=63ef5873&scoped=true"
import script from "./ProductModelDetails.vue?vue&type=script&lang=js"
export * from "./ProductModelDetails.vue?vue&type=script&lang=js"

import "./ProductModelDetails.vue?vue&type=style&index=0&id=63ef5873&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ef5873"]])

export default __exports__